'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;
var videos = void 0;

function init() {
    videos = document.querySelectorAll('.js-video');
    videos = Array.from(videos);
    if (!videos.length) {
        return;
    }

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    videos = videos.map(function (el) {
        return {
            el: el,
            videoID: el.dataset.videoId,
            playlistID: el.dataset.listId,
            player: null,
            play: null,
            playBtn: el.parentNode.parentNode.querySelector('.js-video-play')
        };
    });
}

function onYouTubeIframeAPIReady() {
    videos = videos.map(function (video) {
        var config = {
            height: 470,
            width: 945,
            videoId: video.videoID,
            playerVars: {
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
                widget_referrer: window.location.href
            },
            events: {
                onReady: function onReady(evt) {
                    video.play = evt.target.playVideo.bind(evt.target);
                }
            }
        };

        if (video.playlistID) {
            config.playerVars.list = video.playlistID;
            config.playerVars.listType = 'playlist';
            config.videoId = '';
        }

        video.player = new window.YT.Player(video.el, config);

        if (video.playBtn) {
            video.playBtn.addEventListener('click', function () {
                if (!video.play) {
                    return;
                }

                video.playBtn.classList.add('hidden');
                video.play();
            });
        }

        return video;
    });
}
window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/video.js
// module id = ./resources/assets/js/src/ui/video.js
// module chunks = 0